import itemParser from './parsers/item';
import toError from './parsers/error';
import triggerProgressWhileTranscoding from './trigger-progress-while-transcoding';
import { prepareItemForSending } from './item';

import * as http from '../../utils/http';
import { keysToCamelCase } from '../../utils/object';
import castArray from '../../utils/cast-aray';

const defaultPaging = {
  size: 30,
  cursor: null,
};

const defaultSort = {
  order: 'date',
  direction: 'desc',
};

export default function (settings, adapterMethods) {

  const toItem = _.partial(itemParser, adapterMethods);

  function _parseSuccessResponse(response) {
    const { data } = response;

    return {
      ...response,
      data: _.map(castArray(data), toItem),
    };
  }

  function _connectItemsToList(trigger, itemsResponse, listId) {
    if (!listId) {
      return Promise.resolve(itemsResponse);
    }

    return adapterMethods.list.get(trigger, listId)
      .then(_.property('data.title'))
      .then(listTitle => adapterMethods.listItems.add(trigger, listId, _.map(itemsResponse.data, 'id'))
        .then(function () {
          itemsResponse.data = _.map(itemsResponse.data, data => ({
            ...data,
            usedInLists: [{
              id: listId,
              title: listTitle,
            }],
          }));
        })
      )
      .then(() => adapterMethods.list.publish(trigger, listId));
  }


  function list(trigger, options = {}) {
    const { query, tag, category, mediaType = settings.mediaType } = options;
    let { sort, paging } = options;

    sort = _.merge({}, defaultSort, sort);
    paging = _.merge({}, defaultPaging, paging);

    const { size, cursor } = paging;
    const { direction, order } = sort;

    const params = {
      query,
      tag,
      category,
      media_type: mediaType,
      page_size: size,
      cursor,
      order: direction === 'desc' ? `-${order}` : order,
    };

    return http.get(`${settings.apiUrl}/catalog/items`, { params })
      .then(function (response) {
        const items = _.map(response.data.items, toItem);
        triggerProgressWhileTranscoding(items);

        return _.assign({}, response, {
          sort,
          paging: {
            size,
            cursor: response.data.cursor || null,
          },
          data: items,
        });
      })
      .catch(toError);
  }


  function search(trigger, query, options = {}) {
    return list(trigger, { ...options, query });
  }


  function create(trigger, itemsData) {
    const items = _.map(itemsData, itemData => prepareItemForSending({
      mediaType: settings.mediaType,
      ...itemData,
    }));

    return http.post(`${settings.apiUrl}/catalog/items`, {
        data: { items },
      })
      .then(_parseSuccessResponse)
      .catch(toError);
  }


  function createInList(trigger, itemsData, listId) {
    return adapterMethods.items.create(trigger, itemsData)
      .then(function (itemsResponse) {
        return _connectItemsToList(trigger, itemsResponse, listId)
          .then(() => itemsResponse)
          .catch(() => itemsResponse);
      })
      .catch(toError);
  }


  function update(trigger, itemIds, itemData) {
    const data = prepareItemForSending({
      ...itemData,
      items: castArray(itemIds),
    });

    return http.put(`${settings.apiUrl}/catalog/items`, { data })
      .then(_parseSuccessResponse)
      .catch(toError);
  }


  function remove(trigger, itemIds) {
    const data = {
      items: castArray(itemIds),
    };

    return http.post(`${settings.apiUrl}/catalog/items/delete`, { data })
      .then(keysToCamelCase)
      .catch(toError);
  }


  return {
    list,
    search,
    create,
    createInList,
    update,
    remove,
  };
}



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/items.js